module.exports = __webpack_public_path__ + "static/media/subscribe.e198e2e3.svg";